import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { RestSchemas, useRestClient } from '@/contexts/QueryProvider'
import { IconDeleteOutline } from '@icons/IconDeleteOutline'
import { IconEditOutline } from '@icons/IconEditOutline'
import { IconMenuOutline } from '@icons/IconMenuOutline'
import { ToolForm } from '../Forms/ToolForm'
import { toast } from 'sonner'

type ExistingRegisteredTool = RestSchemas['Messages.Agent.ExistingRegisteredTool']

export function ToolActionsMenu({ tool }: { tool: ExistingRegisteredTool }) {
  const { getToolRegistrationApiListTools, deleteToolRegistrationApiDeleteTool } = useRestClient()

  const invalidateTools = () => {
    getToolRegistrationApiListTools.invalidateQueries(undefined)
  }

  const { mutate: deleteTool } = deleteToolRegistrationApiDeleteTool.useMutation(undefined, {
    onSuccess: () => {
      invalidateTools()
      toast.success('Tool successfully deleted')
    },
    onError: () => {
      toast.error('Error deleting tool')
    },
  })

  const handleDeleteTool = () => {
    deleteTool({
      path: {
        toolId: tool.id,
      },
    })
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" className="size-8 justify-self-end">
          <IconMenuOutline size={16} />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        onCloseAutoFocus={(e) => {
          e.preventDefault()
        }}
      >
        <DropdownMenuLabel>Actions</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <ToolForm
          selectedTool={tool}
          sheetTitle="Edit Tool"
          sheetDescription="Edit the tool"
          onSubmit={invalidateTools}
          sheetTrigger={
            <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
              <div className="flex items-center gap-2">
                <IconEditOutline size={16} />
                <span>Edit tool</span>
              </div>
            </DropdownMenuItem>
          }
        />
        <ConfirmDialog
          title="Confirm Delete"
          description="Are you sure you want to delete this tool?"
          onConfirm={handleDeleteTool}
          confirmVariant="destructive"
          trigger={
            <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
              <div className="flex items-center gap-2">
                <IconDeleteOutline size={16} />
                <span>Delete tool</span>
              </div>
            </DropdownMenuItem>
          }
        />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
